import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("File Explorer")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "Loading...", -1)
const _hoisted_4 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("File Explorer")
const _hoisted_6 = { class: "grid grid-cols-1 space-y-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "flex justify-between space-x-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 text-xs w-full" }, "Name"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 text-xs text-center w-40" }, "Size"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 text-xs text-center w-64" }, "PDA")
], -1)
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "w-40 text-right" }
const _hoisted_11 = { class: "w-64 text-right" }

import { ref, toRefs, watchEffect } from 'vue';
import { PublicKey } from '@solana/web3.js';
import BN from 'bn.js';
import {
  accountPublicKeys, getAccountRoute, shortenPublicKey, toStorageSize,
} from '@/utils';
import { SHDWStorageAccount, SHDWFileAccount } from '@/models';
import { fetchAccount } from '@/api';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null
  },
  setup(__props: any) {

const props = __props as {
  account: SHDWStorageAccount,
}



const { account } = toRefs(props);
// Pagination.
const perPage = 14;
const page = ref(1);
// Lazy-loading.
const loading = ref(true);
const files = ref<SHDWFileAccount[]>([]);

watchEffect(async () => {
  loading.value = true;

  const start = (page.value - 1) * perPage;
  const end = page.value * perPage;
  // clear the values on the array
  files.value.length = 0;

  /* eslint-disable no-await-in-loop */
  for (let i = start; i < account.value.totalFiles; i += 1) {
    const pda = await PublicKey.findProgramAddress(
      [account.value.publicKey.toBuffer(), new BN(i).toTwos(64).toArrayLike(Buffer, 'le', 4)],
      accountPublicKeys.shadowDriveProgram,
    );
    const file = await fetchAccount(pda[0]);

    if (file instanceof SHDWFileAccount) {
      files.value[files.value.length] = file;
    }

    if (files.value.length === perPage) {
      break;
    }
  }

  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_base_label = _resolveComponent("base-label")!
  const _component_icon_loading = _resolveComponent("icon-loading")!
  const _component_icon_document_deleted = _resolveComponent("icon-document-deleted")!
  const _component_icon_document = _resolveComponent("icon-document")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_pagination = _resolveComponent("base-pagination")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _hoisted_3,
        _createVNode(_component_icon_loading, { class: "w-6 h-6 text-gray-500 animate-spin m-auto" })
      ]))
    : (files.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_base_label, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: file.decodedData.name,
                class: _normalizeClass(["flex justify-between hover:bg-gray-300", index % 2 == 0 ? 'bg-white' : 'bg-gray-100'])
              }, [
                _createElementVNode("div", _hoisted_8, [
                  (file.decodedData.toBeDeleted)
                    ? (_openBlock(), _createBlock(_component_icon_document_deleted, {
                        key: 0,
                        class: "h-6 w-6 align-top mr-1",
                        style: {"display":"inline-block"}
                      }))
                    : (_openBlock(), _createBlock(_component_icon_document, {
                        key: 1,
                        class: "h-6 w-6 align-top mr-1",
                        style: {"display":"inline-block"}
                      })),
                  _createElementVNode("a", {
                    href: `https://shdw-drive.genesysgo.net/${_unref(account).publicKey}/${file.decodedData.name}`
                  }, _toDisplayString(file.decodedData.name), 9, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(toStorageSize)(file.decodedData.size)), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    class: "font-mono",
                    to: _unref(getAccountRoute)(file.publicKey)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(shortenPublicKey)(file.publicKey, 10)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ], 2))
            }), 128))
          ]),
          _createVNode(_component_base_pagination, {
            page: page.value,
            "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
            perPage: perPage,
            total: _unref(account).totalFiles
          }, null, 8, ["page", "total"])
        ]))
      : _createCommentVNode("", true)
}
}

})